import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        getColumns({ commit }, serviceId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/kanban/${serviceId}/columns`)
                    .then((res) => {
                        resolve(res.data.data.datas);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        getTypes({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/kanban/types")
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        create({ commit }, form) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/kanban/columns", form)
                    .then((res) => {
                        resolve(res.data.data.column);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        update({ commit }, form) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/kanban/columns/${form.id}`, form)
                    .then((res) => {
                        resolve(res.data.data.column);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete({ commit }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/kanban/columns/${id}`)
                    .then((res) => {
                        resolve(res.data.data.column);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        updateOrder({ commit }, data) {
            const serviceId = data.serviceId;
            const items = data.items;
            return new Promise((resolve, reject) => {
                axios
                    .post(`/kanban/${serviceId}/columns/order`, { items })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        updateAppointmentStatus({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/appointments/${data.id}/status`, {
                        status: data.status,
                        note: data.note,
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        updateAppointmentStatusWithComment({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/appointments/${data.id}/status/with_comment`, {
                        status: data.status,
                        note: data.note,
                    })
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        }
    },

    getters: {},
};
